import { useEffect, useRef } from "react";

const MouseFollower = () => {
  const followerRef = useRef(null);
  const dotRef = useRef(null);

  useEffect(() => {
    const follower = followerRef.current;
    const dot = dotRef.current;

    if (!follower || !dot) return;

    // Mobile / touch devices par hide
    const isTouchDevice =
      window.matchMedia("(hover: none)").matches ||
      window.matchMedia("(pointer: coarse)").matches;

    if (isTouchDevice) {
      follower.style.display = "none";
      dot.style.display = "none";
      return;
    }

    let mouseX = window.innerWidth / 2;
    let mouseY = window.innerHeight / 2;

    let followerX = mouseX;
    let followerY = mouseY;

    let dotX = mouseX;
    let dotY = mouseY;

    let animationFrame;

    const handleMouseMove = (event) => {
      mouseX = event.clientX;
      mouseY = event.clientY;
    };

    const animate = () => {
      // Outer circle - slower movement
      followerX += (mouseX - followerX) * 0.12;
      followerY += (mouseY - followerY) * 0.12;

      // Inner dot - faster movement
      dotX += (mouseX - dotX) * 0.28;
      dotY += (mouseY - dotY) * 0.28;

      follower.style.transform = `translate3d(
        ${followerX}px,
        ${followerY}px,
        0
      ) translate(-50%, -50%)`;

      dot.style.transform = `translate3d(
        ${dotX}px,
        ${dotY}px,
        0
      ) translate(-50%, -50%)`;

      animationFrame = requestAnimationFrame(animate);
    };

    window.addEventListener("mousemove", handleMouseMove);

    animate();

    return () => {
      window.removeEventListener("mousemove", handleMouseMove);
      cancelAnimationFrame(animationFrame);
    };
  }, []);

  return (
    <>
      {/* Outer circle */}
      <div
        ref={followerRef}
        className="
          pointer-events-none
          fixed
          left-0
          top-0
          z-[9999]
          h-12
          w-12
          rounded-full
          border
          border-blue-500/50
          bg-blue-500/[0.03]
          backdrop-blur-[1px]
          transition-[width,height,border-color,background-color]
          duration-200
        "
      />

      {/* Center dot */}
      <div
        ref={dotRef}
        className="
          pointer-events-none
          fixed
          left-0
          top-0
          z-[10000]
          h-1.5
          w-1.5
          rounded-full
          bg-blue-600
        "
      />
    </>
  );
};

export default MouseFollower;